module.exports = __webpack_public_path__ + "static/media/guidesIcon.87b6f498.png";